import './Checkbox.css';

const Checkbox = ({ fieldName, className, checked, onChange }) => (
    <input
        type="checkbox"
        name={fieldName}
        id={fieldName}
        checked={checked}
        className={`checkbox ${className}`}
        onChange={(e) => onChange(e.target.checked)}
    />
);

export default Checkbox;
